import FragmentStore from 'ember-data-model-fragments/store';
import { attachPendingDrafts } from '@linc-technologies/linced-common/utils/dynamic-fields';

// Extend from FragmentStore to resolve Fragments.
export default class Store extends FragmentStore {
  // ember-data defines `pushPayload` as an instance field, not a method, so a
  // method override is never called. Keep the original and replace the field.
  #pushPayload = this.pushPayload;

  // Go encoding/json omits empty arrays, so `{ options: response.options }`
  // can hold `undefined`. The REST serializer wraps it as `[undefined]` and
  // pushes a record with no id. Ember Data 4 made it `[]`. Remove the empty
  // keys to keep that behaviour.
  pushPayload = (modelName, inputPayload) => {
    const payload = inputPayload ?? modelName;
    for (const key in payload) {
      if (payload[key] == null) {
        delete payload[key];
      }
    }

    return this.#pushPayload(modelName, inputPayload);
  };

  // A dynamic fields form shows a default value in a draft field, so that
  // opening the form does not make the record dirty. The save sends the
  // defaults: attach the pending drafts of the record and its fragments first.
  saveRecord(record, options) {
    if (!record.isDeleted) {
      attachPendingDrafts(this, record);
    }
    return super.saveRecord(record, options);
  }
}
